const amplifyconfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
      region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      signUpVerificationMethod: 'code',
      loginWith: {
        email: true,
      }
    }
  }
};

export default amplifyconfig;